/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demoevang_Theologie18Inputs */

const en__field_enum_demoevang_theologie18 = /** @type {(inputs: _Field_Enum_Demoevang_Theologie18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`06 - Evangelische Theorie`)
};

const de__field_enum_demoevang_theologie18 = /** @type {(inputs: _Field_Enum_Demoevang_Theologie18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`06 - Evangelische Theorie`)
};

/**
* | output |
* | --- |
* | "06 - Evangelische Theorie" |
*
* @param {_Field_Enum_Demoevang_Theologie18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demoevang_theologie18 = /** @type {((inputs?: _Field_Enum_Demoevang_Theologie18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demoevang_Theologie18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demoevang_theologie18(inputs)
	return de__field_enum_demoevang_theologie18(inputs)
});
export { _field_enum_demoevang_theologie18 as "_field_enum_DEMOEVANG_THEOLOGIE" }